module.exports = __webpack_public_path__ + "img/37.d2811b8c.jpg";